import { Component, Inject } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'apparatus-dialog-content',
  templateUrl: 'apparatus-dialog-content.html',
})
export class ApparatusDialogContent {
  nameList: string[];
  name1: string[];
  name2: string[];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {    
    this.nameList = data.names;
    //this.name1 = this.nameList[0].split("-");

  }
}
